import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import appStore from "./AppStore";
import MockTermConstants from "./MockTermConstants";

class NowTime extends Component {
    constructor(props) {
        super(props);
        // Don't initialize state based on props.
        this.state = {
            showModal: false,
            selectedNow: appStore.getPrettyPrintedNow(),
            selectedMockDate: null
        };
    }

    submit = () => {
        let newNow = this.state.selectedNow;

        if (this.state.selectedMockDate) {
            newNow = this.state.selectedMockDate;
        }

        if (newNow) {
            appStore.carefullySetNow(newNow);
        } else {
            appStore.clearSetNow();
        }

        this.close();
    }

    handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            this.submit();
        } else {
            this.setState({ selectedNow: event.target.value });
        }
    }

    handleMockDateSelect = (event) => this.setState({ selectedMockDate: event.target.value });
    close = () => this.setState({ showModal: false });
    open = () => this.setState({ showModal: true });

    render() {
        let mockDateOptions = MockTermConstants.MOCK_TERM_SET.map(function (term, index) {
            return (
                <option key={index} value={term.date}>{term.label + " (" + term.date + ")"}</option>
            );
        });

        const OpenComponent = this.props.openComponent;
        let isButtonOpenComponent = OpenComponent.hasOwnProperty("displayName") && OpenComponent.displayName === "Button";

        return (
            <>
                <OpenComponent onClick={this.open} variant={isButtonOpenComponent ? "inline-link":undefined}>Now Time: {appStore.getPrettyPrintedNow()}</OpenComponent>
                <Modal id="modal-now-time"
                       show={this.state.showModal}
                       onHide={this.close}
                       size="sm"
                       aria-labelledby="modal-now-time-title"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="modal-now-time-title">Change Date &amp; Time</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group id="setMockDate">
                            <Form.Label>Pick Mock Date</Form.Label>
                            <Form.Control as="select"
                                          className="form-control"
                                          name="mockDateSelector"
                                          onChange={this.handleMockDateSelect}
                                          defaultValue="">
                                <option value="">Select a date</option>
                                {mockDateOptions}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group id="setNow">
                            <Form.Label>Set 'Now'</Form.Label>
                            <Form.Control
                                type="text"
                                defaultValue={this.state.selectedNow}
                                placeholder="Enter text"
                                onKeyUp={this.handleKeyUp}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.submit} variant="primary">Submit</Button>
                        <Button onClick={this.close} variant="link">Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

NowTime.propTypes = {
    openComponent: PropTypes.elementType
};

NowTime.defaultProps = {
    openComponent: Button
};

export default NowTime;
